import Vue from "vue";

/** Порядок нумерованных блоков. Скрытый (нет данных) не занимает номер. */
const ORDER = ["topics", "dynamics", "posts"];

export const cmHeadVisibility = Vue.observable({
  topics: false,
  dynamics: false,
  posts: false,
});

export function cmHeadNumber(id) {
  let n = 0;
  for (let i = 0; i < ORDER.length; i++) {
    const key = ORDER[i];
    if (!cmHeadVisibility[key]) continue;
    n += 1;
    if (key === id) return String(n).padStart(2, "0");
  }
  return "";
}
